import React, { useEffect, useState } from 'react'
import { TDSLogo } from '../config/images'
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import 'bootstrap/dist/css/bootstrap.min.css';
import { NavLink, Link } from 'react-router-dom';
import EmergencyModal from './modal';

const Header = () => {

    const [headerCollapse, setHeaderCollapse] = useState(false);
    const [windowWidth, setWindowWidth] = useState();
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {

        function windowResize() {
            setWindowWidth(window.outerWidth);
        }

        window.addEventListener('load', windowResize);
        window.addEventListener('resize', windowResize);

        window.addEventListener('emergency', () => { setShowModal(!showModal) })
        return () => {
            window.removeEventListener('load', windowResize);
            window.removeEventListener('resize', windowResize);
            window.removeEventListener('emergency', (function () { })())
        };

    }, [])

    useEffect(() => {
    }, [headerCollapse])

    const collapseMenu = () => {

        if (window.innerWidth < 992) {
            setHeaderCollapse(false)
        }
    }

    const showEmergencyModal = () => {
        setShowModal(true)

        if (window.innerWidth < 992) {
            setHeaderCollapse(false)
        }
    }

    const toggleCollapse = () => {
        setHeaderCollapse(!headerCollapse)
    }


    return (
        <header>


            <Navbar expand="lg" expanded={headerCollapse} className={`${headerCollapse ? 'menu-open' : ''} bg-body-tertiary`} >
                <Container fluid>
                    <Nav.Link className='navbar-brand' as={Link} to="/" onClick={() => collapseMenu()} aria-label="My housing issues gateway">
                        <img className='tds-headerimg' src={TDSLogo}  alt="My housing issues gateway" />
                    </Nav.Link>
                    <div className="d-flex align-items-center d-lg-none ms-auto me-2">
                            <NavLink className="nav-link nav-get-help" onClick={(e) => collapseMenu()} to="/get-advice/questions" aria-label="Get help">Get help</NavLink>
                        </div>

                         <Navbar.Toggle 
                           onClick={() => toggleCollapse()} 
                           aria-controls="basic-navbar-nav" 
                           aria-expanded={headerCollapse}
                           aria-label="Toggle navigation menu"
                         />
                         <Navbar.Collapse id="basic-navbar-nav" className="justify-content-end mobile-mt-10">
                          <Nav className="me-auto justify-content-end flex-grow-1 mobile-nav-list" role="menubar">
                          <NavLink className="nav-link nav-get-help d-none d-lg-inline-block" onClick={(e) => collapseMenu()} to="/get-advice/questions" aria-label="Get help with your housing questions" role="menuitem">Get help</NavLink>
                            <NavLink className="nav-link" onClick={(e) => collapseMenu()} to="/topics" role="menuitem">General Information</NavLink>
                            <NavLink className="nav-link" onClick={(e) => collapseMenu()} to="/news" role="menuitem">News</NavLink>
                            <NavLink className="nav-link" onClick={(e) => collapseMenu()} to="/faq" role="menuitem">FAQ</NavLink>
                            <NavLink className="nav-link" onClick={(e) => collapseMenu()} to="/about" role="menuitem">About</NavLink>
                            {/* <NavLink  className="nav-link" onClick={(e) => collapseMenu()} to="/contact">Contact</NavLink> */}
                            
                            <NavLink className="nav-link color-red emergency-link" onClick={(e) => { e.preventDefault(); showEmergencyModal(); }} to="#" role="menuitem" aria-label="Emergency help - open emergency information modal">Emergency</NavLink>
                            <NavLink
                              className="nav-link get-help-here d-lg-none"
                              onClick={(e) => collapseMenu()}
                              to="/get-advice/questions"
                              role="menuitem"
                              aria-label="Get help here (mobile only)"
                            >
                              Get help here
                            </NavLink>
                            

                        </Nav>
                    </Navbar.Collapse>
                    <EmergencyModal
                        show={showModal}
                        onHide={() => setShowModal(false)}
                    />
                </Container>
            </Navbar>

        </header>
    )
}

export default Header
